import { dateLib } from '@/fsd/shared/lib';
import { useHttpClient } from '../../http/index';
import { GetOperationsHistoryResponse, GetOperationsHistoryParams } from './types';

const { get, delete: cancel } = useHttpClient();

const buildQuery = (params: Partial<GetOperationsHistoryParams>) => {
  const query = new URLSearchParams();

  if (params.startDate) query.set('start_date', params.startDate);
  if (params.endDate) query.set('end_date', params.endDate);
  if (params.status) query.set('status', params.status);
  if (params.operations) {
    params.operations.forEach((op) => query.append('operations[]', op));
  }
  if (params.account_type && params.account_uuid) {
    query.set('account_type', params.account_type);
    query.set('account_uuid', params.account_uuid);
  }
  query.set('number', String(params.number));
  query.set('size', String(params.size ?? 20));

  return query.toString();
};

export const useOperationsHistoryApi = () => {
  const getOperationsHistory = async (params: GetOperationsHistoryParams) => {
    const queryString = buildQuery(params);
    const { data, pagination } = await get<GetOperationsHistoryResponse>(`/v1/office/financial_operations?${queryString}`);

    return {
      data: data.map((item) => ({
        ...item.attributes,
        createdAt: dateLib.formatDate(new Date(item.attributes.createdAt), 'DD.MM.YYYY, HH:mm'),
        createdAtRaw: new Date(item.attributes.createdAt),
        createdAtMonth: dateLib.formatLocalizedDate(new Date(item.attributes.createdAt), params.locale, 'MMMM'),
        amountRaw: parseFloat(item.attributes.amount.replace(/[^\d.-]/g, '')),
        amountWithCommissionRaw: parseFloat(item.attributes.amountWithCommission.replace(/[^\d.-]/g, '')),
        commissionRaw: parseFloat(item.attributes.commission.replace(/[^\d.-]/g, '')),
      })),
      pagination,
    };
  };

  const deleteOperation = async (id: string) => {
    await cancel(`/v1/office/withdrawals/${id}`, {
      errorHandlerOptions: {
        skipErrorByOneOfCodes: [],
      },
    });
  };

  return {
    getOperationsHistory,
    deleteOperation,
  };
};
